import { createContext, useContext, useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MaintenanceContext = createContext(null);

export function MaintenanceProvider({ children }) {
  const [maintenance, setMaintenance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchStatus = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/maintenance-status`);
        const data = await response.json();
        if (!cancelled) setMaintenance(data);
      } catch (error) {
        if (!cancelled) setMaintenance({ maintenance_mode: false });
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchStatus();

    return () => { cancelled = true; };
  }, []);

  return (
    <MaintenanceContext.Provider value={{ maintenance, loading }}>
      {children}
    </MaintenanceContext.Provider>
  );
}

export function useMaintenance() {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error("useMaintenance must be used within a MaintenanceProvider");
  }
  return context;
}
